$(function() {

	$.nette.ext('suggest', {
		init: function() {
			var snippetsExt = this.ext('snippets', true);
			var ext = this;

			snippetsExt.after(function($el) {
				ext.init.call(ext, $el);
			});

			this.init($(document));
		}
	}, {
		selector: '.suggest',

		init: function($el) {
			var ext = this;

			$el.find(this.selector).each(function() {
				var Suggest = new sk.widgets.Suggest($(this), {
					minLength: 2,
					typeInterval: 250,
					url: $(this).data('suggest')
				});

				var $menu = $('<div class="search-suggest"></div>');
				if($(this).hasClass('suggest-interactions')) {
					$(this).closest('.suggest-wrap').prepend($menu);
				} else {
					$(this).closest('form').after($menu);
				}

				var SuggestMenu = new sk.widgets.SuggestMenu($menu, Suggest).init();
				$(SuggestMenu).on('menuselect', function(e, initiatorEvent) {
					var $a = this.$items.eq(this.selectedIndex - 1).find('a');
					var $input = Suggest.$input;
					if ($input.attr('data-suggest-fill')) {
						var text = $a.data('suggest-value') || $a.text();
						$input.val(text).trigger('blur');
						$input.next('.suggestAutocompleteButton').click();
					} else {
						var newLocation;
						if (initiatorEvent.type === "click") {
							newLocation = $(initiatorEvent.target).closest('a').attr('href');

							if ( ! newLocation) {
								newLocation = $(initiatorEvent.target).find('a').attr('href');
							}
						}
						else if (initiatorEvent.type === "enter") {
							newLocation = $a.attr('href');
						}

						if (newLocation) {
							window.location.href = newLocation;
						}

						return false;
					}

					this.hide();
				})
			});
		}
	});

});
